import Constants from '@/constants/const';
import { getCookie, setCookie } from '@/utils/cookie';

export function updateSessionTokenMaxAge() {
  const sessionToken = getCookie(Constants.WEEE_SESSION_TOKEN);
  if (!!sessionToken) {
    setCookie(Constants.WEEE_SESSION_TOKEN, sessionToken, null, { maxAge: Constants.WEEE_SESSION_TOKEN_MAX_AGE });
  }
}
